import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT } from "../../../../services/index";
import { message } from "antd";

export const useFetchUser = () => {
  return useQuery(
    ["getFetchUser"],
    async (value) => {
      try {
        const endpoint = `/api/v1/usersbackoffice/list`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load User..");
      }
    }
  );
};


export const UseFetchCreateUser = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/usersbackoffice`;
      const result = await POST(endPoint, payload);
      message.success("Create User Success..");
      
      return result;
    } catch (error) {
      await message.destroy();
      message.error(error.response.data.message);
    }
  });
};

export const UseFetchUpdateUser = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/usersbackoffice`;
      const result = PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Update User..");
    }
  });
};

